import React from 'react'
import PropTypes from 'prop-types'

import { IconType, Icon, Link } from '@raysync/common/components'
import CmsContentService from '../../../services/cms-content-service'
import {
  PostCardContainer,
  PostCardImg,
  PostCardContent,
  PostCardTitle,
  PostCardIntro,
  PostCardDate,
  PostCardMsg,
} from './atoms'
import TagImg from './tag.png'

class CmsPostCard extends React.PureComponent {
  render() {
    const { title, slug, content, date, isBlog, isSearchCard, imgSrc, tags = [] } = this.props
    const coverImgSrc = isSearchCard ? imgSrc : CmsContentService.getCoverImg(content)
    const intro = isSearchCard ? content : CmsContentService.getText(content)
    return (
      <PostCardContainer>
        <Link to={`/${isBlog ? 'blog' : 'news'}/${slug}/`}>
          <PostCardImg>{coverImgSrc ? <img src={coverImgSrc} alt={title} /> : <div></div>}</PostCardImg>
        </Link>
        <PostCardContent>
          <PostCardTitle>
            <Link to={`/${isBlog ? 'blog' : 'news'}/${slug}/`}>{title || ''}</Link>
          </PostCardTitle>
          <PostCardIntro>{intro}</PostCardIntro>
          <PostCardMsg>
            <PostCardDate>
              <Icon type={IconType.Clock} />
              {date}
              {tags && tags.length ? (
                <>
                  {tags
                    .filter(tag => !!tag.isBlog === !!isBlog)
                    .map(item => (
                      <Link to={`/${isBlog ? 'blog' : 'news'}/${item.slug}/`}>{item.name}</Link>
                    ))}
                </>
              ) : null}
            </PostCardDate>
          </PostCardMsg>
        </PostCardContent>
      </PostCardContainer>
    )
  }
}

export default CmsPostCard
